import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { ILanguageRequest, ILanguageVariableList, ILanguageVariableFilterRequest, ILanguageVariableReportLookupData } from '@nkr/models/index';
import { IDelete } from '../authorization/actions';



export interface IVariableReportListResponse {
    data: {
        success: boolean,
        message: string,
        results: ILanguageVariableList[]
    }
}

export interface IVariableReportLookUpResponse {
    data: {
        success: boolean,
        message: string,
        results: ILanguageVariableReportLookupData
    }
}


export interface IVariableTextResponse {
    data: {
        success: boolean,
        message: string,
        result: string
    }
}



export const ActionCreators = {

    getVariableReportList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IVariableReportListResponse> => {
        let options = {
            url: `${__API__}/language/get-all-variable-list`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },


    getFilteredVariableReportList: (request: ILanguageVariableFilterRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IVariableReportListResponse> => {
        let options = {
            url: `${__API__}/language/filter-variable-list`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },


    saveVariableRecord: (request: ILanguageRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IVariableReportListResponse> => {
        let options = {
            url: __API__ + '/language/save-new-variable',
            data: request
        }

        if (request.variableId == 0) {
            return await dispatch(AuthActionCreators.apiPost(options));
        } else {
            return await dispatch(AuthActionCreators.apiPut(options));
        }
    },

    deleteVariableRecord: (variableId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {

        var options: IDelete = {
            url: __API__ + `/language/delete-new-variable?variableId=${variableId}`
        };

        return await dispatch(AuthActionCreators.apiDelete(options));
    },

 
    getVariableReportLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IVariableReportLookUpResponse> => {
        let options = {
            url: `${__API__}/language/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },



    getVariableText: (request: ILanguageRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IVariableTextResponse> => {
        let options = {
            url: __API__ + '/language/get-variable-text',
            data: request
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    }

}